import { EmissionsCategoryEnum } from '@shared/api/types';
import { cn } from '@shared/lib/utils';
import { ClassValue } from 'clsx';

import cloudA from './labels/cloud/label-a.png';
import cloudB from './labels/cloud/label-b.png';
import cloudC from './labels/cloud/label-c.png';
import cloudD from './labels/cloud/label-d.png';
import cloudE from './labels/cloud/label-e.png';

import cloudScaleA from './labels/cloud-scale/label-a.png';
import cloudScaleB from './labels/cloud-scale/label-b.png';
import cloudScaleC from './labels/cloud-scale/label-c.png';
import cloudScaleD from './labels/cloud-scale/label-d.png';
import cloudScaleE from './labels/cloud-scale/label-e.png';

import fullA from './labels/full/label-a.png';
import fullB from './labels/full/label-b.png';
import fullC from './labels/full/label-c.png';
import fullD from './labels/full/label-d.png';
import fullE from './labels/full/label-e.png';

export type LabelVariantType = 'cloud' | 'cloud-scale' | 'full';

const images: Record<
  LabelVariantType,
  Record<EmissionsCategoryEnum, string>
> = {
  cloud: { A: cloudA, B: cloudB, C: cloudC, D: cloudD, E: cloudE },
  'cloud-scale': {
    A: cloudScaleA,
    B: cloudScaleB,
    C: cloudScaleC,
    D: cloudScaleD,
    E: cloudScaleE,
  },
  full: { A: fullA, B: fullB, C: fullC, D: fullD, E: fullE },
};

export interface LabelVariantProps {
  variant: LabelVariantType;
  rating?: EmissionsCategoryEnum;
  className?: ClassValue;
}

const LabelVariant = ({
  variant,
  rating = 'A',
  className,
}: LabelVariantProps) => {
  const src = images[variant][rating];

  return (
    <img
      src={src}
      className={cn('object-contain', className)}
      alt={`${variant} label, rating ${rating}`}
    />
  );
};

export default LabelVariant;
